import styled from 'styled-components';

const withCollapse = (component) => styled(component)(({ theme, collapse }) => `
  max-height: 100vh;
  transition: all ${theme.speeds.moderate};
  ${collapse ? `
    max-height: 0;
    margin-top: 0;
    margin-bottom: 0;
    border-width: 0;
    padding-top: 0;
    padding-bottom: 0;
    grid-gap: 0;
  ` : ''}
`);

export default withCollapse;
